import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './telemetry'; // Application Insights — no-op if VITE_APPINSIGHTS_CONNECTION_STRING not set
import { watchForResume } from './lib/resume';

// #499 — the live views reload their data when the app comes back after a gap.
watchForResume();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA + push notifications
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => { /* no service worker here (http, an old browser): push stays off, and the push hint says so */ });
}
